import React from 'react';
import { connect } from 'react-redux';
import ReactPagination from 'react-js-pagination';
import { loadRecords } from '../../actions/records';

class Pagination extends React.PureComponent {
  handleChange = (paginationIdx) => {
    const {
      recordBook,
      recordPageIdx,
      recordPageCount,

      dispatch,
      sortInverse,
      sortTerm,
    } = this.props;

    const idx = paginationIdx - 1;
    if (idx === recordPageIdx) return;
    if (recordBook[idx].length) {
      dispatch({ type: 'SET_RECORD_PAGE_IDX', payload: idx });
    } else if (recordPageIdx < recordPageCount) {
      dispatch({ type: 'SET_RECORDS_LOADING', payload: true });
      dispatch({ type: 'SET_RECORD_PAGE_IDX', payload: idx });
      loadRecords({
        desc: sortInverse,
        sort: sortTerm,
        page: paginationIdx,
      })
        .then(() => {
          dispatch({ type: 'SET_RECORDS_LOADING', payload: false });
        }).catch(() => {
          dispatch({ type: 'SET_RECORDS_LOADING', payload: false });
        });
    }
  };

  render() {
    const {
      recordPageIdx,
      recordPageSize,
      recordPageCount,
      innerClass,
    } = this.props;

    return (
      <ReactPagination
        activePage={recordPageIdx + 1}
        itemsCountPerPage={recordPageSize}
        totalItemsCount={recordPageCount * recordPageSize}
        pageRangeDisplayed={5}
        innerClass={`pagination position-fixed ${innerClass || ''}`}
        itemClass="page-item"
        linkClass="page-link"
        onChange={this.handleChange}
      />
    );
  }
}

const mapStateToProps = (store) => ({
  recordBook: store.records.recordBook,
  recordPageIdx: store.records.recordPageIdx,
  recordPageSize: store.records.recordPageSize,
  recordPageCount: store.records.recordPageCount,

  agencyFilter: store.records.agencyFilter,
  searchTerm: store.records.searchTerm,
  sortInverse: store.records.sortInverse,
  sortTerm: store.records.sortTerm,
});

export default connect(mapStateToProps)(Pagination);
